// Avis clients (Google reviews) — modifier ici pour mettre à jour
export const TESTIMONIALS = [
  {
    name: "Camille Roffi",
    rating: 5,
    text:
      "J'ai fait une séance d'Hypnose Future Life avec Valentine et j'ai adoré ! Je pensais ne pas être très réceptive à l'hypnose alors que j'ai réellement voyagé, j'ai pu avoir des pistes et identifier clairement mes besoins pour l'avenir et notamment ma vie professionnelle. Valentine est très douce, à l'écoute, sa voix est très agréable et posée, un gros atout pour l'hypnose. J'y retournerai c'est certain et vous recommande vivement ses services. Merci encore Valentine.",
  },
  {
    name: "Benjamine Clémentin",
    rating: 5,
    text:
      "Étant dans une phase de ma vie plutôt complexe et difficile, j'ai ressenti le besoin de prendre un temps pour moi, pour reprendre du souffle, de me reconnecter à moi-même. C'est donc tout naturellement que je suis allée consulter Valentine pour une séance d'hypnose spirituelle. Menée par sa voix enveloppante et rassurante, j'ai pu, au fil des mots, m'apaiser et me laisser entraîner dans ce qui fût une expérience enrichissante, lumineuse et profondément relaxante. J'ai ressenti un véritable bien-être après la séance. Valentine m'a fait voyager au cœur de mon être avec bienveillance. Je ne peux que vous encourager à vivre cette belle expérience.",
  },
  {
    name: "Eve D.",
    rating: 5,
    text:
      "J'ai fait une séance avec Valentine et j'ai vraiment beaucoup apprécié l'expérience ! C'est la première fois que j'arrive autant à me laisser porter avec un(e) hypnothérapeute. D'habitude, je ne suis pas très réceptive à ce genre de pratique mais elle m'a complètement réconciliée avec ça ! Sa voix est très agréable, elle est très douée, je ne peux que vous la recommander ! Merci encore pour le voyage Valentine !",
  },
  {
    name: "Virginie Audusseau",
    rating: 5,
    text:
      "J'ai consulté Valentine à deux reprises, pour une hypnose régressive et pour une hypnose dans le futur, et je ne peux que recommander son professionnalisme et sa douceur. Valentine m'a tout de suite mise à l'aise, m'a bien expliqué le déroulé de la séance et a été à l'écoute de mes ressentis pendant et après. Je me suis sentie en sécurité et mes expériences ont été fortes en émotions et en apprentissages. Rencontrer mon moi passé et mon moi futur m'a apporté beaucoup d'apaisement et de joie. Je garde un beau voyage intérieur, merci Valentine.",
  },
  {
    name: "Ludivine Mercier",
    rating: 5,
    text:
      "Je viens de vivre une séance… déroutante ! J'ai opté pour une séance d'hypnose du futur parce que j'étais très curieuse. Et je n'ai pas été déçue ! J'écris cet avis en étant encore à moitié plongée dans mon futur. Quelle joie de vivre ces moments de bonheur purs et de sérénité. Rencontrer mon « moi » du futur m'a fait beaucoup de bien. Merci beaucoup Valentine pour ta douceur et ce moment bien agréable qui continue d'infuser. Une jolie rencontre.",
  },
  {
    name: "Naja",
    rating: 5,
    text:
      "Dès l'entretien préliminaire, Valentine a su me mettre à l'aise grâce à sa qualité d'écoute et à sa douceur. Pendant le soin, j'ai ressenti les énergies œuvrer à des endroits localisés de mon corps en lien avec ma problématique. Elle m'a rapidement fait un retour écrit détaillé et pertinent. J'ai commencé à me sentir plus posée, plus sereine. Alors que cela faisait des mois que je traversais une situation professionnelle difficile, une proposition concrète dans un domaine qui me tient à cœur m'est « tombée dessus ». Je prépare ma rentrée avec enthousiasme et gratitude.",
  },
  {
    name: "Alexis Teissier",
    rating: 5,
    text:
      "Une expérience rare et étonnante avec Valentine. Pourtant sceptique au départ, elle m'a permis de voyager bien au-delà des limites de mon imagination. Cette séance a élargi ma perception. Très belle expérience, je recommande. Hâte de recommencer. Merci Valentine.",
  },
  {
    name: "Claire Besson",
    rating: 5,
    text:
      "J'ai fait une très belle séance avec Valentine. Son approche est douce, rassurante, et très pro. Je la recommande chaleureusement.",
  },
];

export const AVERAGE_RATING = 5;
export const REVIEW_COUNT = TESTIMONIALS.length;
